"use client"

import { useLocation, useNavigate } from "react-router-dom"
import { motion } from "framer-motion"
import { ArrowLeft, CreditCard, AlertCircle } from "lucide-react"
import "../styles/compra.css"
import "../styles/resumoPedido.css"

const ResumoPedido = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const locationState = location.state || {}
  const {
    pedidoId,
    nome = "Não informado",
    categoriaSelecionada = "Não especificada",
    senhasEscolhidas = {},
    totalPedido = 0,
    evento,
    boiTvSelecionado = {},
    boiTvValores = {},
    taxasOpcionaisSelecionadas = []
  } = locationState

  if (!pedidoId || pedidoId === "undefined") {
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="resumo-container fluxo-compra-simples resumo-simples"
      >
        <h2>Erro no Resumo do Pedido</h2>
        <div className="resumo-erro">
          <AlertCircle size={24} />
          <p>ID do pedido não encontrado. Volte e tente novamente.</p>
        </div>
        <motion.button
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
          onClick={() => navigate(-1)}
          className="btn-voltar"
        >
          <ArrowLeft size={18} />
          Voltar
        </motion.button>
      </motion.div>
    )
  }

  return (
    <motion.main
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="resumo-container fluxo-compra-simples resumo-simples"
    >
      <header className="flow-simple-header">
        <span className="flow-step-badge">Confira</span>
        <div>
          <h1>Seu pedido</h1>
          <p>Veja se está tudo certo.</p>
        </div>
      </header>

      <section className="simple-order-person">
        <strong>{nome}</strong>
        <span>{categoriaSelecionada}</span>
      </section>

      <section className="simple-order-list">
        {Object.keys(senhasEscolhidas).length > 0 ? (
          Object.entries(senhasEscolhidas).map(([index, { dia, numero }]) => {
            const foiSelecionadoBoiTv = boiTvSelecionado?.[index]
            const valorBoiTv = boiTvValores?.[index] || 0
            const taxaOpcional = taxasOpcionaisSelecionadas?.[index]

            return (
              <div key={index} className="simple-order-ticket">
                <div className="simple-ticket-number">
                  <small>Senha {Number.parseInt(index) + 1}</small>
                  <strong>{numero}</strong>
                </div>
                <div className="simple-ticket-info">
                  <strong>{dia}</strong>
                  {foiSelecionadoBoiTv && (
                    <span>
                      Boi TV {Number(valorBoiTv) === 0
                        ? "grátis"
                        : `• ${Number(valorBoiTv).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}`}
                    </span>
                  )}
                  {taxaOpcional && <span>{taxaOpcional.nome}</span>}
                </div>
              </div>
            )
          })
        ) : (
          <p>Nenhuma senha selecionada.</p>
        )}
      </section>

      {evento?.boletoParcelado?.ativo && (
        <div className="simple-installment-note">Boleto parcelado disponível</div>
      )}

      <section className="simple-order-total">
        <span>TOTAL</span>
        <strong>{Number(totalPedido).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</strong>
      </section>

      <div className="simple-order-actions">
        <button type="button" className="simple-secondary-button" onClick={() => navigate(-1)}>
          <ArrowLeft size={18} /> VOLTAR
        </button>
        <button
          type="button"
          className="simple-primary-button"
          onClick={() =>
            navigate("/pagamento", {
              state: {
                pedidoId,
                nome,
                categoriaSelecionada,
                senhasEscolhidas,
                totalPedido,
                eventoid: evento?._id || "não informado",
                nomeEvento: evento?.nome || "Evento não identificado",
                evento,
              },
            })
          }
        >
          <CreditCard size={20} /> PAGAR AGORA
        </button>
      </div>
    </motion.main>
  )
}

export default ResumoPedido